import getScrollPositionOfPage from 'commons/getScrollPositionOfPage';

const getBottomPositionOfElement = element => {
  if (!element) {
    return null;
  }
  const boundingRect = element.getBoundingClientRect();
  const bottomOfElement = getScrollPositionOfPage() + boundingRect.bottom;
  return bottomOfElement;
};

export default getBottomPositionOfElement;
